// Configuration
import { getEnvironmentConfig, API_PREFIX, setupEnvironmentListener } from './config/apiConfig';

// Authentication
import { 
  getValidAdminToken, 
  adminLogout, 
  handleIpError, 
  debugAuthState,
  debugAuthentication,
  checkTokenValidity,
  // New admin auth functions
  setAdminToken,
  getAdminToken,
  setAdminUser,
  getAdminUser,
  setAdminSession,
  getAdminSession,
  clearAdminAuthData,
  isAdminAuth,
  getCurrentAdmin,
  adminHasPermission,
  adminHasRole
} from './auth/authManager';

// Endpoint Management
import { 
  resetDynamicEndpoints,
  getSelectedEndpoint,
  getAvailableEndpoints,
  hasPrimaryEndpoint,
  getPrimaryEndpoint,
  getEndpointStatus,
  discoverAndValidateEndpoints,
  refreshEndpointStatus
} from './endpoints/endpointManager';

// New Admin Endpoint Manager
import {
  getAdminEndpoint,
  setAdminEndpoint,
  getAllAdminEndpoints,
  AUTH_ENDPOINTS,
  MANAGEMENT_ENDPOINTS
} from './endpoints/adminEndpointManager';

// Config Service Endpoint Manager
import {
  getConfigEndpoint,
  setConfigEndpoint,
  hasConfigEndpoint,
  clearConfigEndpoint,
  storeEndpointsList,
  getStoredEndpointsList,
  getFirstActiveEndpoint
} from './endpoints/configEndpointManager';

// Base API
import { getCurrentApi, adminRequest, authServiceRequest } from './api/baseAPI';

// API Modules
import { authAPI } from './api/authAPI';
import { adminAuthAPI } from './api/adminAuthAPI';
import { adminManagementAPI } from './api/adminManagementAPI';
import { instrumentAPI } from './api/instrumentAPI';
import { historyAPI } from './api/historyAPI';
import { serviceAPI } from './api/serviceAPI';
import { endpointAPI } from './api/endpointAPI';
import { userAPI } from './api/userAPI';
import { engineRoleAPI } from './api/engineRoleAPI';
import { adminSettingsAPI } from './api/adminSettingsAPI';
import { positionAPI } from './api/positionAPI';
import { fundsAPI } from './api/fundsAPI';
import { groupsAPI } from './api/groupsAPI';
import subRoleAPI from './api/subRoleAPI';
import { apiKeyAPI } from './api/apiKeyAPI';
import { liquidityThresholdAPI } from './api/liquidityThresholdAPI';
import { orderAuditAPI } from './api/orderAuditAPI';
import { platformSettingsAPI } from './api/platformSettingsAPI';

// Utilities
import { 
  debugAuth, 
  safeTokenCheck, 
  testApiAuthentication, 
  testCorsSupport 
} from './utils/apiUtils';

// Form State Management
import formStateManager from './utils/formStateManager';

// Initialize environment listener
setupEnvironmentListener(resetDynamicEndpoints);

// Initialize debugging on startup
debugAuthState();

// Export all API modules and utilities
export {
  // Configuration
  getEnvironmentConfig,
  API_PREFIX,
  
  // Authentication
  getValidAdminToken,
  adminLogout,
  handleIpError,
  debugAuthState,
  debugAuthentication,
  checkTokenValidity,
  // New admin auth functions
  setAdminToken,
  getAdminToken,
  setAdminUser,
  getAdminUser,
  setAdminSession,
  getAdminSession,
  clearAdminAuthData,
  isAdminAuth,
  getCurrentAdmin,
  adminHasPermission,
  adminHasRole,
  
  // Endpoint Management
  getSelectedEndpoint,
  getAvailableEndpoints,
  hasPrimaryEndpoint,
  getPrimaryEndpoint,
  getEndpointStatus,
  discoverAndValidateEndpoints,
  refreshEndpointStatus,
  
  // New Admin Endpoint Manager
  getAdminEndpoint,
  setAdminEndpoint,
  getAllAdminEndpoints,
  AUTH_ENDPOINTS,
  MANAGEMENT_ENDPOINTS,
  
  // Config Service Endpoint Manager
  getConfigEndpoint,
  setConfigEndpoint,
  hasConfigEndpoint,
  clearConfigEndpoint,
  storeEndpointsList,
  getStoredEndpointsList,
  getFirstActiveEndpoint,
  // Base API
  getCurrentApi,
  adminRequest,
  authServiceRequest,
  
  
  // API Modules
  authAPI,
  adminAuthAPI,
  adminManagementAPI,
  instrumentAPI,
  historyAPI,
  serviceAPI,
  endpointAPI,
  userAPI,
  engineRoleAPI,
  adminSettingsAPI,
  positionAPI,
  fundsAPI,
  groupsAPI,
  subRoleAPI,
  apiKeyAPI,
  liquidityThresholdAPI,
  orderAuditAPI,
  platformSettingsAPI,
  
  // Utilities and Debug Functions
  debugAuth,
  safeTokenCheck,
  testApiAuthentication,
  testCorsSupport,
  
  // Form State Management
  formStateManager
};

// Default export is the getCurrentApi function for backward compatibility
export default getCurrentApi; 